import {
  EdiSchemaType,
  SourceOutputExampleType,
  sourceOutputExampleTypeToJSON
} from '~/protos/agents'

export const InputOutputExamples = [
  {
    label: 'XML -> JSON',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_XML),
    input: `
<?xml version='1.0' encoding='UTF-8'?>
<order>
  <product>
    <price>5</price>
    <model>MuleSoft Connect 2016</model>
  </product>
  <item_amount>3</item_amount>
  <payment>
    <payment-type>credit-card</payment-type>
    <currency>USD</currency>
    <installments>1</installments>
  </payment>
  <buyer>
    <email>mike@hotmail.com</email>
    <name>John Doe</name>
    <address>Koala Boulevard 314</address>
    <city>San Diego</city>
    <state>CA</state>
    <postCode>1345</postCode>
    <nationality>USA</nationality>
  </buyer>
  <shop>main branch</shop>
  <salesperson>Mathew Chow</salesperson>
</order>
        `.trim(),
    output: `
{
  "address1": "Koala Boulevard 314",
  "city": "San Diego",
  "country": "USA",
  "email": "mike@hotmail.com",
  "first_name": "John",
  "last_name": "Doe",
  "postalCode": "1345",
  "stateOrProvince": "CA"
}
         `.trim()
  },
  {
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON),
    label: 'JSON -> JSON',
    input: `
[
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 1,
    "marks": 9
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 2,
    "marks": 9.5
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 3,
    "marks": 8
  },
  {
    "sid": 101,
    "sname": "Rahul",
    "sem": 4,
    "marks": 7
  }
]
        `.trim(),
    output: `
 [
  {
    "SID": 101,
    "SNAME": "Rahul",
    "CGP": 8.375
  }
]
         `.trim()
  },
  {
    label: 'JSON -> XML Example 1',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON),
    input: `
{
  "superhero": "Muletron",
  "dataSnacks": ["XML Cookies", "JSON Jellies", "API Apples", "Binary Biscuits"]
}
        `.trim(),
    output: `
<?xml version='1.0' encoding='UTF-8'?>
<superhero>
  <name>Muletron</name>
  <snackSaga>
    <snack>XML Cookies</snack>
  </snackSaga>
  <snackSaga>
    <snack>JSON Jellies</snack>
  </snackSaga>
  <snackSaga>
    <snack>API Apples</snack>
  </snackSaga>
  <snackSaga>
    <snack>Binary Biscuits</snack>
  </snackSaga>
</superhero>
         `.trim()
  },
  {
    label: 'JSON -> XML Example 2',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_JSON),
    input: `
{
  "AcesPayload": [
    {
      "ID": "ID_X1",
      "FACILITY_NUM": [101, 202, 303],
      "NAME": "LOCATION ALPHA",
      "A_VENDORNAME": "VENDOR_XYZ_001",
      "A_VENDOR": "001"
    },
    {
      "ID": "ID_X2",
      "FACILITY_NUM": [404, 505, 606],
      "NAME": "LOCATION BETA",
      "A_VENDORNAME": "VENDOR_ABC_002",
      "A_VENDOR": "002"
    }
  ],
  "locLookup": [
    {
      "FACILITYID": "101_Loc_A",
      "FACILITYNUM": 101
    },
    {
      "FACILITYID": "202_Loc_B",
      "FACILITYNUM": 202
    },
    {
      "FACILITYID": "303_Loc_C",
      "FACILITYNUM": 303
    },
    {
      "FACILITYID": "404_Loc_D",
      "FACILITYNUM": 404
    },
    {
      "FACILITYID": "505_Loc_E",
      "FACILITYNUM": 505
    },
    {
      "FACILITYID": "606_Loc_F",
      "FACILITYNUM": 606
    }
  ]
}
        `.trim(),
    output: `
<?xml version='1.0' encoding='UTF-8'?> 

<STEP-ProductInformation ExportTime="2025-02-25 01:52:29" ExportContext="Context1" ContextID="Context1" WorkspaceID="Main" UseContextLocale="false">

  <Classifications>

    <Classification ID="ID_X1" UserTypeID="TESTVENDOR" ParentID="PARENTTESTVENDOR">
      <Name>VENDOR_XYZ_001</Name>

      <ClassificationCrossReference ClassificationID="101_Loc_A" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="202_Loc_B" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="303_Loc_C" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="404_Loc_D" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="505_Loc_E" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="606_Loc_F" Type="VendorToFacilityLink"/>

      <MetaData>
        <Value AttributeID="a_VendorName">LOCATION ALPHA</Value>
        <Value AttributeID="a_Vendor">001</Value>
      </MetaData>
    </Classification>

    <Classification ID="ID_X2" UserTypeID="TESTVENDOR" ParentID="PARENTTESTVENDOR">
      <Name>VENDOR_ABC_002</Name>

      <ClassificationCrossReference ClassificationID="101_Loc_A" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="202_Loc_B" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="303_Loc_C" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="404_Loc_D" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="505_Loc_E" Type="VendorToFacilityLink"/>
      <ClassificationCrossReference ClassificationID="606_Loc_F" Type="VendorToFacilityLink"/>

      <MetaData>
        <Value AttributeID="a_VendorName">LOCATION BETA</Value>
        <Value AttributeID="a_Vendor">002</Value>
      </MetaData>
    </Classification>

  </Classifications>

</STEP-ProductInformation>
         `.trim()
  },
  {
    label: 'YAML -> JSON',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_YAML),
    input: `
name: starwars collection
year of publication:
    - 1977
    - 1980
    - 1983
movies:
# Only movies from the original trilogy (OT) are listed here.
    ot:
       - Episode IV - A New Hope
       - Episode V - The Empire Strikes Back
       - "Episode VI - Return of the Jedi Knights."
        `.trim(),
    output: `
[
   {
      "year":1977,
      "ot":"Episode IV - A New Hope"
   },
   {
      "year":1980,
      "ot":"Episode V - The Empire Strikes Back"
   },
   {
      "year":1983,
      "ot":"Episode VI - Return of the Jedi Knights."
   }
]
         `.trim()
  },
  {
    label: 'EDI -> JSON',
    inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_EDI),
    inputEdiSchemaType: {
      transactionVersion: '004010',
      transactionType: '850'
    } as EdiSchemaType,
    input: `
ISA*00*          *00*          *ZZ*NTORETAIL      *01*MYTHICAL       *200915*0103*U*00401*000000018*0*P*>~
GS*PO*NTORETAIL      *MYTHICAL       *20200915*0103*18*X*004010~
ST*850*0001~
BEG*00*NE*PO-DEMO-20200912-002**20191018~
REF*VR*7429271~
PER*BD*Tim Brown*EM*tbrown@nto.com~
PO1*1*20**34.45****MG*324791~
PID*F****8.5″ x 11″ Copy Paper, 20 lbs, 92 Brightness, 5000/Carton (324791)~
N1*ST*Salesforce West*92*338~
N3*50 Fremont St*Suite 1456~
N4*San Francisco*CA*94105*US~
PO1*2*80**1.95****MG*2072174~
PID*F****Hype Tank Highlighters, Chisel, Yellow, Dozen (29203)~
N1*ST*Salesforce East*92*367~
N3*350 Mission St*Floor 5~
N4*San Francisco*CA*94105*US~
PO1*3*65**5.08****MG*163865~
PID*F****Notepads, 8.5″ x 11.75″, Wide Ruled, White, 50 Sheets/Pad, 12 Pads/Pack (51295/2~
N1*ST*Salesforce Tower*92*587~
N3*415 Mission St*Floor 3~
N4*San Francisco*CA*94105*US~
PO1*4*30*PH*11.77****MG*467951~
PID*F****Lightweight Moving & Storage Packing Tape, 1.88″W x 54.6 Yards, Clear, 6 Rolls (~
N1*ST*Tableau Palo Alto*92*1564~
N3*260 California Ave*Ste 300~
N4*Palo Alto*CA*94306*US~
CTT*4~
SE*26*0001~
GE*1*18~
IEA*1*000000018~
        `.trim(),
    output: `
[
  {
    "PurchaseOrder": {
      "POPurpose": "New",
      "POType": "NE",
      "PONumber": "PO-DEMO-20200912-002",
      "CustomerId": "A43836686",
      "CustomerName": "Ohana Incorporated",
      "BuyerName": "Tim Brown",
      "BuyerEmailID": "tbrown@nto.com",
      "PODate": "2019-10-18T00:00:00-07:00",
      "POLineItems": [
        {
          "PurchaseOrderLineId": "PO-DEMO-20200912-002-0",
          "LineNum": "1",
          "Quantity": "20",
          "UnitPrice": "34.45",
          "ItemDescription": "8.5″ x 11″ Copy Paper, 20 lbs, 92 Brightness, 5000/Carton (324791)",
          "SupplierItemNum": "324791",
          "POLineLocation": {
            "LineLocationId": "338",
            "ShipToLocation": {
              "ShipToLocationCode": "338",
              "ShipToLocationName": "Salesforce West",
              "Address": {
                "AddressLine1": "50 Fremont St",
                "AddressLine2": "Suite 1456",
                "City": "San Francisco",
                "PostalCode": "94105",
                "State": "CA",
                "Country": "US"
              }
            }
          }
        },
        {
          "PurchaseOrderLineId": "PO-DEMO-20200912-002-1",
          "LineNum": "2",
          "Quantity": "80",
          "UnitPrice": "1.95",
          "ItemDescription": "Hype Tank Highlighters, Chisel, Yellow, Dozen (29203)",
          "SupplierItemNum": "2072174",
          "POLineLocation": {
            "LineLocationId": "367",
            "ShipToLocation": {
              "ShipToLocationCode": "367",
              "ShipToLocationName": "Salesforce East",
              "Address": {
                "AddressLine1": "350 Mission St",
                "AddressLine2": "Floor 5",
                "City": "San Francisco",
                "PostalCode": "94105",
                "State": "CA",
                "Country": "US"
              }
            }
          }
        },
        {
          "PurchaseOrderLineId": "PO-DEMO-20200912-002-2",
          "LineNum": "3",
          "Quantity": "65",
          "UnitPrice": "5.08",
          "ItemDescription": "Notepads, 8.5″ x 11.75″, Wide Ruled, White, 50 Sheets/Pad, 12 Pads/Pack (51295/2",
          "SupplierItemNum": "163865",
          "POLineLocation": {
            "LineLocationId": "587",
            "ShipToLocation": {
              "ShipToLocationCode": "587",
              "ShipToLocationName": "Salesforce Tower",
              "Address": {
                "AddressLine1": "415 Mission St",
                "AddressLine2": "Floor 3",
                "City": "San Francisco",
                "PostalCode": "94105",
                "State": "CA",
                "Country": "US"
              }
            }
          }
        },
        {
          "PurchaseOrderLineId": "PO-DEMO-20200912-002-3",
          "LineNum": "4",
          "Quantity": "30",
          "UnitPrice": "11.77",
          "ItemDescription": "Lightweight Moving & Storage Packing Tape, 1.88″W x 54.6 Yards, Clear, 6 Rolls (",
          "SupplierItemNum": "467951",
          "POLineLocation": {
            "LineLocationId": "1564",
            "ShipToLocation": {
              "ShipToLocationCode": "1564",
              "ShipToLocationName": "Tableau Palo Alto",
              "Address": {
                "AddressLine1": "260 California Ave",
                "AddressLine2": "Ste 300",
                "City": "Palo Alto",
                "PostalCode": "94306",
                "State": "CA",
                "Country": "US"
              }
            }
          }
        }
      ]
    }
  }
]
          `.trim()
  }
  //   {
  //     label: 'EDIFACT -> JSON',
  //     inputType: sourceOutputExampleTypeToJSON(SourceOutputExampleType.DATA_TYPE_EDIFACT),
  //     inputEdiFactSchemaType: {
  //       version: 'd01b',
  //       message: 'ORDERS',
  //     } as EdiFactSchemaType,
  //     input: `
  // UNB+UNOB:1+SENDER1:14:ZZUK+RECEIVER1:1:ZZUK+071101:1701+131++ORDERS++1++1'
  // UNH+000000101+ORDERS:D:96A:UN'
  // BGM+220+128576+9'
  // DTM+137:20020830:102'
  // PAI+::42'
  // FTX+ZZZ+1+001::91'
  // RFF+CT:652744'
  // DTM+171:20020825:102'
  // NAD+BY+5412345000013::9'
  // RFF+VA:87765432'
  // CTA+OC+:P FORGET'
  // COM+0044715632478:TE'
  // NAD+SU+4012345500004::9'
  // RFF+VA:56225432'
  // CUX+2:GBP:9+3:EUR:4+1.67'
  // DTM+134:2002080120020831:718'
  // TDT+20++30+31'
  // TOD+3++CIF:23:9'
  // LOC+1+BE-BRU'
  // LIN+1++4000862141404:SRS'
  // PIA+1+ABC1234:IN'
  // IMD+C++TU::9'
  // QTY+21:48'
  // MOA+203:699.84'
  // PRI+AAA:14.58:CT:AAE:1:KGM'
  // RFF+PL:AUG93RNG04'
  // DTM+171:20020801:102'
  // PAC+2+:51+CS'
  // PCI+14'
  // LOC+7+3312345502000::9'
  // QTY+11:24'
  // DTM+2:20020915:102'
  // LOC+7+3312345501003::9'
  // QTY+11:24'
  // DTM+2:20020913:102'
  // TAX+7+VAT+++:::17.5+S'
  // UNS+S'
  // CNT+2:1'
  // UNT+38+000000101'
  // UNZ+1+131'
  //         `.trim(),
  //     output: `
  // [
  //   {
  //     "B2BMessage": {
  //       "Header": {
  //         "CustomerReference": "131",
  //         "BuyerGLN": "5412345000013",
  //         "CompanyGLN": "4012345500004",
  //         "RequestedReceiptDate": "20020830",
  //         "MessageType": "ORDERS",
  //         "OrderDate": "20020825"
  //       },
  //       "Data": {
  //         "PurchaseOrder": {
  //           "POLineItems": [
  //             {
  //               "GTINCode": "0000000000000",
  //               "Quantity": "48",
  //               "ExternalItemCode": "ABC1234"
  //             }
  //           ]
  //         }
  //       }
  //     }
  //   }
  // ]
  //       `.trim(),
  //   }
] as const
